import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromGlobalStore from '@shared/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseComponent } from '../helpers/base-component';
import { SiteConfigService } from './site-config.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedOutBackgroundService extends BaseComponent {
  public posterImage: string;
  public componentData: { layout: string };
  public hasHomepageHero = new BehaviorSubject<boolean>(false);
  public heroImage$: Observable<string> = this.ngrxStore
    .select(fromGlobalStore.getSpecificCustomAsset, { customAsset: 'prelogin_hero' })
    .pipe(
      map((res) => {
        if (res && res.length > 0) {
          this.posterImage = `${res[0].file}`;
          this.hasHomepageHero.next(true);
          return `url('${res[0].file}')`;
        } else {
          return '';
        }
      })
    );

  public backgroundImage$: Observable<string> = this.heroImage$.pipe(
    map((image) => {
      if (image) {
        return this.componentData.layout !== 'modern'
          ? `var(--ten-logged-out-header-container-background), ${image}`
          : `var(--ten-logged-out-header-container-background), var(--ten-logout-top-section-gradient-background), ${image}`;
      } else {
        return 'var(--ten-logged-out-header-container-background), var(--ten-homepage-hero-image)';
      }
    })
  );

  constructor(
    private ngrxStore: Store<any>,
    siteConfService: SiteConfigService
  ) {
    super(siteConfService, 'background-image');
  }
}
